export default "__VITE_ASSET__CiOxIed7__"